import React, { Component } from 'react';
import Dialog from 'react-bootstrap-dialog';
import { connect } from 'react-redux';
import { checkInvitationLink } from '../redux/actions/user-actions';
import { Row, Col } from 'react-bootstrap';
import logoFooter from '../images/logo_footer_inflo.png';
import logo from '../images/inflo_logo.png';
import LoginInfloPage from '../features/login/components/login/LoginInfloPage';
import InfloWelcome from '../features/login/components/InfloWelcome';
import RegisterInfloForm from '../features/login/components/register/RegisterInflo';
import Logo from '../components/widgets/Logo';
import MobileFooter from '../components/widgets/MobileFooter';
import { BrowserView, MobileView } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import { CONSTANTS } from '../constants/constants';
import VisitorMessagePanel from '../features/visitorMessagePanel/components/visitorMessagePanel';

class RegisterOnBoardingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      component: 'registerOnBoarding'
    };
  }

  componentDidMount() {
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.code
    ) {
      this.props.dispatch(checkInvitationLink(this.props.match.params.code));
    }
  }

  redirectToLoginInflo = () => {
    this.setState({ component: 'loginInflo' });
  };

  redirectToRegisterInflo = () => {
    this.setState({ component: 'registerInflo' });
  };

  redirectToInfloWelcome = () => {
    this.setState({ component: 'infloWelcome' });
  };

  renderPanel = (showCopyright = false) => {
    return (
      <>
        <form className="loginForm signinForm24" onSubmit={this.onSubmit}>
        <div style={{fontSize: 20, fontWeight: 400, marginTop: 72, marginBottom: 32}}>Welcome to Inflo!</div>

        {!this.props.consumedLink ?
          <>
          <div className="form-group">
            <button
              class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
              onClick={this.redirectToRegisterInflo.bind(this)}
              >
              I am a New User
            </button>
          </div>
          <div class="c-horizontal_content_rule" style={{width: '70%', margin: 'auto', marginTop: 16, marginBottom: 24}}>
            <hr class="c-horizontal_content_rule__leftrule divider24" />
              <div class="c-horizontal_content_rule__content">or</div>
              <hr class="c-horizontal_content_rule__rightrule divider24" />
          </div>
          <div className="form-group">
            <button
              class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
              onClick={this.redirectToLoginInflo.bind(this)}
              >
              I Have an Account
            </button>
          </div>
          </>
          :
            <>
              <div
                className="col-md-12"
                style={{
                  width: 250,
                  margin: '24px auto'
                }}
              >
                We're sorry, this link is no longer valid.
              </div>
              <div
                className="col-md-12"
                style={{ textAlign: 'center' }}
              >
                <button
                  class="login-btn button-oval button-signin24 button-brand24 inflo24-gradient "
                  onClick={this.redirectToLoginInflo.bind(this)}
                // type="submit"
                >
                  Sign In
                </button>
              </div>
            </>
  }
        </form>

        {showCopyright && (
          <div style={{marginTop: 72}}>
          <MobileFooter />
          </div>
          )}
      </>
    )
  }

  render() {
    if (
      this.state.component &&
      this.state.component !== 'loginInflo' &&
      this.state.component !== 'infloWelcome' &&
      this.state.component !== 'registerInflo'
    ) {
      return (
        <React.Fragment>

          <MobileView viewClassName="mv mobile-signin-panel">
            <Helmet>
              {/* <style>{'body { background-color: #121C24!important; }'}</style> */}
            </Helmet>
            <Logo />
            <Dialog
              ref={(el) => {
                this.dialog = el;
              }}
            />
            {this.renderPanel(true)}
          </MobileView>
          <BrowserView>
          <Helmet>
              {/* <style>{'body { background-color: white!important; }'}</style> */}
            </Helmet>
            <div>
                <div className="paddingBlockInflo login-inflo-page"
                   style={{
                     background: `url(${CONSTANTS.heroImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'top center',
                    backgroundSize: 'cover'
                  }}
                >
                  <div className='browser-signin-panel'>
                    <Logo />
                    <Dialog
                      ref={(el) => {
                        this.dialog = el;
                      }}
                    />
                    {this.renderPanel()}
                    {this.state.currentPanel !== 'forgotPassword' && CONSTANTS.showEXIQ && (
                      <div className="footerInflo footerExIQ">
                        Inflo users&nbsp;
                        <div className="linkFooterInflo">
                          <div
                            style={{ textDecoration: 'underline' }}
                            onClick={this.redirectToInfloWelcome}
                          >
                           continue here »
                          </div>

                        </div>
                      </div>
                    )}
                  </div>
                <VisitorMessagePanel />
                </div>
                <MobileFooter />
            </div>
            <Helmet>
              {/* <style>{'body { background-color: white!important; }'}</style> */}
            </Helmet>
            <div>
              <Dialog
                ref={(el) => {
                  this.dialog = el;
                }}
              />
              <div className="paddingBlockInflo login-inflo-page">
                {/* <Row
                  className="show-grid"
                  style={{ marginRight: '0', marginLeft: '0' }}
                >
                  <Col xs={5} className="loginInfloForm">
                    <div className="logoInflo">
                      <div style={{ float: 'left', marginRight: '45px' }}>
                        <img src={logo} alt="logo" />
                      </div>
                    </div>
                    {!this.props.consumedLink ? (
                      <>
                        <form>
                          <div style={{ textAlign: 'center' }}>
                            <button
                              onClick={this.redirectToRegisterInflo.bind(this)}
                              className="btn login-inflo-button"
                            >
                              I am a New User
                            </button>
                          </div>{' '}
                          <div
                            style={{
                              textAlign: 'center',
                              fontSize: '20px',
                              marginBottom: '5px'
                            }}
                          >
                            Or
                          </div>
                        </form>
                        <div className="row" style={{ textAlign: 'center' }}>
                          <button
                            onClick={this.redirectToLoginInflo.bind(this)}
                            className="btn login-inflo-button"
                          >
                            I have an Account
                          </button>
                        </div>
                      </>
                    ) : (
                      <div>
                        <div
                          className="col-md-12"
                          style={{
                            textAlign: 'center',
                            color: '#E31690',
                            fontSize: '20pt',
                            fontWeight: '500',
                            marginBottom: '15px'
                          }}
                        >
                          Unfortunately, this link is not valid anymore.
                        </div>
                        <div
                          className="col-md-12"
                          style={{ textAlign: 'center' }}
                        >
                          <div
                            className="btn login-inflo-button"
                            onClick={this.redirectToLoginInflo.bind(this)}
                          >
                            Back to Login
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div id="linksInflo">
                        <span style={{ color: '#a1a1a1' }}>
                          © Copyright 2022 Inflo, Inc.
                        </span>{' '}
                        |{' '}
                        <a
                          className="linkpaInflo"
                          href="https://www.notecast.app/privacy/"
                        >
                          Privacy Policy
                        </a>{' '}
                        |{' '}
                        <a
                          className="linkpaInflo"
                          href="https://www.notecast.app/legal/"
                        >
                          License Agreement
                        </a>
                      </div>
                    </div>
                  </Col>
                </Row> */}
              </div>
            </div>
            {CONSTANTS.showEXIQ && (
              <div className="footerInflo footerExIQ">
                Inflo users&nbsp;
                <div className="linkFooterInflo">
                  <div
                    style={{ textDecoration: 'underline' }}
                    onClick={this.redirectToInfloWelcome}
                  >
                    continue here »
                  </div>

                </div>
              </div>
            )}
          </BrowserView>
        </React.Fragment>
      );
    } else if (
      this.state.component &&
      this.state.component === 'infloWelcome'
    ) {
      return <InfloWelcome />;
    } else if (
      this.state.component &&
      this.state.component === 'registerInflo'
    ) {
      return <RegisterInfloForm code={this.props.match.params.code} />;
    } else {
      return <LoginInfloPage />;
    }
  }
}

const mapStateToProps = (store) => {
  return {
    consumedLink: store.user.consumedLink
  };
};

export default connect(mapStateToProps)(RegisterOnBoardingPage);
